




import { defineComponent, onMounted, ref, shallowRef, toRef, watch } from "@vue/composition-api";
import { Chart, ChartConfiguration, LineController, LineElement, PointElement, LinearScale, Title } from "chart.js";

export default defineComponent({
  name: "StatisticChart",
  props: {
    config: { type: Object as () => ChartConfiguration, required: true },
  },
  setup(props) {
    const canvasEl = ref<HTMLCanvasElement>();
    const chart = shallowRef<Chart | null>(null);

    const createChartJs = (): void => {
      // tslint:disable-next-line:no-unused-expression
      if (!canvasEl.value) return;
      chart.value = new Chart(canvasEl.value, props.config);
    };
    const recreateChartJs = (): void => {
      chart.value?.destroy();
      createChartJs();
    };

    onMounted(() => {
      Chart.register(LineController, LineElement, PointElement, LinearScale, Title);
      createChartJs();
    });

    watch(toRef(props, "config"), (newValue, oldValue) => {
      if (newValue && oldValue && chart.value) {
        recreateChartJs();
      }
    });

    return {
      canvasEl,
    };
  },
});
